module.exports = __webpack_public_path__ + "d288a6768456cb68cf55c873c7dbbab3.fbx";